import {Injectable, NgZone} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ToolbarConfig } from '../models/toolbarconfig';

@Injectable({
  providedIn: 'root'
})
export class ToolbarService {

  toolbarConfig$ = new BehaviorSubject<ToolbarConfig>(undefined);
  navigationBlocked$ = new BehaviorSubject<boolean>(false);

  constructor(private ngZone: NgZone) {
  }

  setToolbarConfig(toolbarConfig: ToolbarConfig): void {
    this.toolbarConfig$.next(toolbarConfig);
  }

  /**
   * Block navigation controls. Doesn't block back button (not possible).
   *
   * Used to discourage rapid screen changes depending on asynchronous resources (camera).
   *
   * @param blocked
   */
  setNavigationBlocked(blocked: boolean) {
    this.ngZone.run(() => {
      this.navigationBlocked$.next(blocked);
    });
  }
}
